function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createUseStyles } from 'react-jss';
var useStyles = createUseStyles(function (_ref) {
  var palette = _ref.palette,
    spacing = _ref.spacing,
    breakpoints = _ref.breakpoints,
    elevation = _ref.elevation,
    type = _ref.type;
  return {
    pageContainer: {
      backgroundColor: palette.background.main,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    },
    hashMessageId: {
      fontFamily: type.fontFamily.base,
      color: '#6B787F',
      fontSize: 12,
      position: 'fixed',
      bottom: 24,
      right: 0,
      left: 0,
      textAlign: 'center',
      margin: 0
    },
    childrenContainer: _defineProperty({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }, "@media (max-width: ".concat(breakpoints.sm, "px), (max-height: ").concat(breakpoints.sm, "px)"), {
      position: 'static'
    }),
    pageLogoLink: {
      display: 'inline-block',
      position: 'relative',
      zIndex: elevation.sky,
      margin: spacing[5],
      width: 200,
      height: 30
    }
  };
});
export default useStyles;
//# sourceMappingURL=useErrorPageStyles.js.map